import React from 'react';
import styles from './Footer.module.css';

import logo from '../../images/Footer/лс_визитка(black) (1)-1-Photoroom 1.png'
import viber from '../../images/Footer/Vector.png'
import telegram from '../../images/Footer/lyra-icon-telegram.png'
import whatsapp from '../../images/Footer/lyra-icon-whatsapp.png'
import instagram from '../../images/Footer/instagram.png'
import {Link} from "react-router-dom";

const Footer = () => {

    const handleOpenRules = () => {
        window.open('/privacy/privacy.html', '_blank');
    };
    return (
        <div className={styles.container}>
            <div className={styles.row}>
                <div style={{textAlign: 'center'}}  className={styles.column}>
                    <img  className={styles.logo} src={logo} alt="Logo"/>
                </div>
                <div className={styles.column}>
                    <div className={styles.icons}>
                        <a target="_blank" href="viber://chat?number=%2B380951347728"><img src={viber} alt="viber"/></a>
                        <a target="_blank" href="https://t.me/+380951347728"><img src={telegram} alt="telegram"/></a>
                        <a target="_blank" href="https://wa.me/+380951347728"><img src={whatsapp} alt="whatsapp"/></a>
                        <a target="_blank" href="https://www.instagram.com/pixelgameua/"><img src={instagram} alt="whatsapp"/></a>
                    </div>
                    <div className={styles.links}>
                        <a target="_blank" href="https://pixelgame.com.ua">pixelgame.com.ua</a> <br/>
                        <a target="_blank" href="mailto:pixelgameua@gmail.com" style={{position: 'relative', top: '14px'}} >pixelgameua@gmail.com</a>

                    </div>
                </div>
                <div className={styles.column}>
                    <div className={styles.column_2} style={{position: 'relative', bottom: '16px'}}>
                        <div className={styles.links_2}>
                            <div><a target="_blank" href="https://pixelgame.com.ua">pixelgame.com.ua</a></div>
                            <div><a target="_blank" href="mailto:pixelgameua@gmail.com">pixelgameua@gmail.com</a></div>
                        </div>
                        <a className={styles.number} href="tel:+380951347728">
                            <span>+380 (95) 134-77-28</span>
                        </a>
                        <br/>
                        <a className={styles.number} href="tel:+380997508446">
                            <span>+380 (99) 750-84-46</span>
                        </a>
                        <Link to="https://maps.app.goo.gl/MLKUCdpCAGqyzWzFA" target="_blank" rel="noopener noreferrer"><p className={styles.address_p}>Дніпро, вул. Автотранспортна, 2<br/> БЦ "City BC", оф. 402</p></Link>
                    </div>

                </div>
            </div>
            <div className={styles.row_2}>
                <Link to="/privacy" target="_blank" rel="noopener noreferrer"><h2>Політика конфіденційності</h2></Link>
                <p>Design by Anastasiia Khushan</p>
            </div>
        </div>
    );
};

export default Footer;